import React, { useState } from 'react';
import { NoFollowLink } from 'shared/no-follow-link';
import { getFrontEndUrl } from 'utils/environment-util';

interface IProps {
  className?: string;
  defaultZipCode?: string;
  prefillZipCode?: boolean;
}

export const ZipCodeInput: React.FC<IProps> = ({ className, defaultZipCode, prefillZipCode }) => {
  const [zipCode, setZipCode] = useState<string>((prefillZipCode && defaultZipCode) || '');
  return (
    <div
      className={`relative flex h-12 w-full flex-row rounded-lg bg-white text-base text-neutral-800 md:w-[320px] ${className}`}>
      <div className='absolute left-1 top-[-1px] flex h-full items-center px-2 '>
        <i className='fal fa-location-dot' />
      </div>
      <input
        placeholder='Enter your ZIP code'
        type='number'
        value={zipCode}
        onChange={(event) => setZipCode(event.currentTarget.value)}
        className='h-full w-full rounded-lg border-none bg-white pl-9 placeholder:font-medium placeholder:text-neutral-700 focus:border-none'
      />
      <NoFollowLink
        href={`${getFrontEndUrl()}/explore/zip/${zipCode ?? defaultZipCode}`}
        className='absolute right-1 top-1 h-10 w-[125px] rounded-lg bg-radish-200 px-4 py-2 font-medium text-white'>
        Find food
        <i className='fal fa-chevron-right ml-3' />
      </NoFollowLink>
    </div>
  );
};
